import { TFunction } from "i18next";
import { OptionType } from "../../../services/helpers/types";

export const createTooltip = (
  values: string[],
  t: TFunction,
): React.ReactNode => {
  const finalTooltip = values.join("\n");
  return (
    <div className="dui-select-tooltip">
      {t("currentValue")}: <br />
      {finalTooltip}
    </div>
  );
};

export const createMultiSelectTooltip = (
  values: string[],
  options: OptionType[],
  t: TFunction,
): React.ReactNode => {
  const tooltipValues = values.map((value) => {
    const option = options.find((option) => option.value === value);
    if (option) {
      return option.name;
    }
    return value;
  });

  const finalTooltip = tooltipValues.join("\n");

  return (
    <div className="dui-select-tooltip">
      {t("currentValue")}: <br />
      {finalTooltip}
    </div>
  );
};
